<template>
  <div class="total bgps flex fd">
    <theader />
    <div class="content f1 flex fd">
      <div class="zbbox flex jb ac">
        <div
            ref='backImg'
            class="zblist1"
            v-for="(i, j) in zbdata"
        >
          <div  class="img-back">
            <refreshImg height="100%" :duration='15000' :imgUrl="backImgSrc(i)"></refreshImg>
          </div>


          <!-- <img class="img-back" :src="backImgSrc(i)" alt=""> -->
          <img class="front-img" :src="i.url" alt="" />
          <div class="count-box"">
          <countTo
              class="count"
              ref="countTo"
              :startVal="0"
              :endVal="+materialsInfo[i.value]||0"
              :duration="3000"
              :autoplay="true"
          ></countTo>


          <p style="font-size: 0.68vw">{{ i.label }}</p>
        </div>
      </div>
    </div>
    <div class="f1 main flex">
      <div class="mainsingle flex fd" style="gap: 1.04vw; width: 54.17vw">
        <div class="bluebg flex fd f1">
          <longbluetitle :titlearr="['材料分析']" />
          <div class="charts f1 flex">
            <div class="chartsleft flex fd ac" style="gap: 0.83vw">
              <div @click="arrowClick('up')" class="arrow arrow-up">
                <!-- <img src="@/assets/image/situation/三角形@2x.png" alt="" /> -->
              </div>
              <div class="type-content" ref="scroll">
                <div
                    style="
                    width: 100%;
                    height: 2.08vw;
                    background: #16385e;
                    border-radius: 0.42vw;
                    backdrop-filter: blur(5px);
                    line-height: 2.08vw;
                    text-align: center;
                  "
                    :style="{
                    background:
                      typeValue == i
                        ? 'linear-gradient( 270deg, rgba(0,165,230,0.9) 0%, rgba(0,123,228,0.8) 25%, #165691 57%, rgba(0,108,200,0) 100%)'
                        : '#16385E',
                  }"
                    v-for="(i, j) in typedata"
                    @click="typecheck(i)"
                >
                  {{ i }}
                </div>
              </div>

              <div  @click="arrowClick('down')" class="arrow arrow-down">
                <!-- <img src="@/assets/image/situation/三角形@2x.png" alt="" /> -->
              </div>
            </div>
            <div class="chartsright f1 flex fd">
              <div class="righttop flex jb">
                <div
                    class="righttopsingle flex ac"
                    v-for="(i, j) in righttopdata"
                >
                  <img :src="i.url" alt="" />
                  <div>
                    <p
                        style="
                          color: #d9e7ff;
                          font-size: 0.68vw;
                          margin-bottom: 0.52vw;
                        "
                    >
                      {{ i.label }}
                    </p>
                    <p style="color: #d9e7ff; font-size: 1.25vw">
                      {{ materialsInfo[i.value] }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="rightbot f1 flex">
                <div style="width: 100%" id="firstcharts"></div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="flex fd "  :style="{ gap: videoData.length !== 0 ? '0.76vw' : '' }">
        <div class="mainsingle bluebg flex fd" style="width: 37.19vw">
          <div v-if="videoData.length!==0" style="height: 17.71vw; margin-bottom: 1.042vw" class="flex fd">
            <longbluetitle :titlearr="['过磅监控']" />
            <bluetitle
                :active="selectVedio"
                :titlearr="vediowArr"
                @tabnum1="changeVedio"
                style="background: url(''); width: 50%;position: absolute;right: 0;"
            />
            <div class="doorlist f1 flex">
              <div class="kongbox" >
                <vidobox  :showBottom="false" :imgUrl ='vedioDataItem.imageUrl' :id= "'veds'+vedioDataItem.channelName" :url="vedioDataItem.liveUrl" :list="vedioDataItem"
                          width="375" height="220"  :kheight="'40px'" :kbottom="'0px'" :token="vedioDataItem.token" />
              </div>
            </div>
          </div>
        </div>
        <div class="mainsingle bluebg flex fd f1" style="width: 37.19vw">
          <div class="f1 flex fd">
            <div
                style="
                 margin-bottom: 0.78vw
              "
                class="flex jb ac "
            >
              <longbluetitle :titlearr="['过磅记录']" />

            </div>
            <div class="inoutlist f1">
              <div class="kongbox" v-if="recordReceiveData.length===0">
                <img src="../assets/image/暂无数据@2x.png" alt="" />
                <p>暂无项目数据</p>
              </div>
              <t-table
                  :bordered="false"
                  rowKey="index"
                  stripe
                  :rowClassName = "(params)=> params.rowIndex%2===0?'bg-color':''"
                  :data="recordReceiveData"
                  :columns="columns"
                  :onChange= 'tableChange'
                  :pagination="pagination"
                  style="overflow: hidden"
                  v-else
              ></t-table>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <tmenu />
  </div>
</template>

<script>
import refreshImg from '@/components/common/refreshImg.vue';
import countTo from 'vue-count-to'
import {getMaterialsType,getMaterialsInfo, getMaterialsReceive,getVideo} from '@/utils/metrialApi'
import * as echarts from 'echarts';
export default {
  components:{countTo,refreshImg},
  data() {
    return {
      start:true,
      // titlearr: [
      //   { label: '今日', select: 'day' },
      //   { label: '本周', select: 'week' },
      //   { label: '本月', select: 'month'},
      // ],
      selectRange:'day',
      pagination: {
        defaultCurrent: 1,
        defaultPageSize:5,
        total: 10,
        current:1,
        pageSize:10,
        showPageSize:false,

      },
      columns: [
        { colKey: 'receiveDate', title: '进场日期',ellipsis:true },
        { colKey: 'materialName', title: '物资名称',ellipsis:true },
        { colKey: 'model', title: '规格型号',ellipsis:true },
        { colKey: 'supplier', title: '供料单位',ellipsis:true },
        { colKey: 'producer', title: '生产厂家',ellipsis:true },
        { colKey: 'unit', title: '计量单位',ellipsis:true },
        { colKey: 'deliveryOrderNum', title: '送货单数量',ellipsis:true },
        { colKey: 'weighingQuantity', title: '过磅数量',ellipsis:true },
        { colKey: 'settlementNum', title: '结算数量',ellipsis:true },
        { colKey: 'subcontractors', title: '分包单位',ellipsis:true },
      ],
      recordReceiveData: [],
      righttopdata: [
        {
          label: '预算量（吨）',
          value: 'totalBudgetedAmount',
          url: require('../assets/image/编组.png'),
        },
        {
          label: '采购量（吨）',
          value: 'totalPurchaseAmount',
          url: require('../assets/image/编组(1).png'),
        },
        {
          label: '收料量（吨）',
          value: 'totalReceiveMaterialAmount',
          url: require('../assets/image/编组(2).png'),
        },
        {
          label: '库存余量（吨）',
          value: 'totalInventoryMargin',
          url: require('../assets/image/编组(3).png'),
        },
      ],
      typeValue: '全部材料',
      typedata: ['全部材料'],
      zbdata: [
        {
          label: '本月采购量(吨)',
          value: 'totalPurchaseAmountMonth',
          url: require('../assets/image/meterial/本月采购.png'),
        },
        {
          label: '本月收料量(吨)',
          value: 'totalReceiveAmountMonth',
          url: require('../assets/image/meterial/本月收料.png'),
        },
        {
          label: '本月出料量（吨）',
          value: 'totalMaterialDeliveredAmountMonth',
          url: require('../assets/image/meterial/本月出料.png'),
        },
        {
          label: '当前库存余量（吨）',
          value: 'totalCurrentInventoryMarginMonth',
          url: require('../assets/image/meterial/库存余量.png'),
        },
        {
          label: '累积超负差次数',
          value: 'cumulativeExcessNegativeDifferencesTotal',
          url: require('../assets/image/meterial/超负差.png'),
        },
        {
          label: '本月超负差次数',
          value: 'excessNegativeDifferencesMonth',
          url: require('../assets/image/meterial/超负差.png'),
        },
      ],
      tabnums1: 0,
      gunlist: [
        { label: '全部项目', select: 1 },
        { label: '项目001', select: 0 },
        { label: '项目002', select: 0 },
        { label: '项目003', select: 0 },
        { label: '项目004', select: 0 },
      ],
      materialsInfo:{},
      alltableArr:[
        [ {
          title:'全部材料',
          children:[
            {lable:'预算总量',value:'totalBudgetedAmount'}
          ]
        },{
          title:'材料占比',
          materialsInfoProp:'budgetedAmountPercentageByType',
          isExpand :false,
        }],
        [ {
          title:'全部材料',
          children:[
            {lable:'采购总量',value:'totalPurchaseAmountMonth'},
            {lable:'预算偏差',value:'budgetedDifference'}
          ]
        },{
          title:'材料占比',
          materialsInfoProp:'purchaseAmountPercentageByType' ,
          isExpand :false,
        }], [ {
          title:'全部材料',
          children:[
            {lable:'收料总量',value:'totalReceiveMaterialAmount'},
            {lable:'采购偏差',value:'budgetedDifference'}
          ]
        },{
          title:'材料占比',
          materialsInfoProp:'receiveMaterialAmountPercentageByType'    ,
          isExpand :false,
        }] ,[ {
          title:'全部材料',
          children:[
            {lable:'库存总余量',value:'totalInventoryMargin'},
          ]
        },{
          title:'材料占比',
          materialsInfoProp:'inventoryMarginPercentageByType',
          isExpand :false,
        }]
      ],
      singleMaterialArr:[
        [{
          label:'预算量',
          value:'totalBudgetedAmount'
        },{
          label:'占比',
          isPercent:true,
          value:'budgetedAmountRatio'
        },],
        [{
          label:'采购量',
          value:'totalPurchaseAmount'
        },{
          label:'占比',
          value:'purchaseAmountRatio',
          isPercent:true,
        },{
          label:'预算偏差',
          value:'budgetedDifference',
          isPercent:true,
        },],
        [{
          label:'收料量',
          value:'totalReceiveMaterialAmount'
        },{
          label:'占比',
          value:'receiveAmountRatio',
          isPercent:true,
        },{
          label:'采购偏差',
          value:'purchaseDifference',
          isPercent:true,
        },], [{
          label:'库存余量',
          value:'totalInventoryMargin'
        },{
          label:'占比',
          value:'inventoryAmountRatio',
          isPercent:true,
        },]
      ],
      videoData:[],
      vediowArr:[],
      selectVedio:0,
      vedioDataItem:{},
      outSideData:[],
      insideData:[]
    };
  },
  methods: {
    backImgSrc(i) {
      const date = new Date().getTime()
      return (i.label == '累积超负差次数') ||
      (i.label == '本月超负差次数') ?
          `meterial/图标背景-黄.png` : `meterial/图标背景.png`

    },

    changeVedio(e, i) {
      this.selectVedio = i.select
      this.vedioDataItem = this.vedioData[i.select]
    },
    arrowClick(type) {
      const wrap = this.$refs.scroll
      if (type === 'up') {
        wrap.scrollTop -= 50;
      } else {
        wrap.scrollTop += 50;
      }

    },
    clickArrow(el) {
      el.isExpand = !el.isExpand
    },
    typecheck(e) {
      this.typeValue = e
      this.getMaterialsInfo()
    },
    //处理占比数据
    formatRatio(data) {
      const str = data * 100
      return str.toFixed(2)
    },
    initfirst() {

      var chartDom = document.getElementById('firstcharts');
      var myChart = echarts.init(chartDom);
      var option;
      const minWidth = (this.insideData[0]?.value / this.outSideData[0].value).toFixed(2) || 0
      const left = (1 - minWidth).toFixed(2) / 2
      option = {
        tooltip: {
          backgroundColor: "rgba(46,83,127,0.4)",
          borderWidth: 0,
          className: 'echarts-tooltip',
          trigger: 'item',
          formatter: (params) => {
            let html = ''
            const nameMap = {
              '采购量': '预算偏差',
              '收料量': '采购偏差',
            }
            if (this.typeValue === '全部材料') {
              //加join是解决','隔开的问题
              html = `
                      <div  style='color:#fff; padding: 0 0.52vw; '>
                        <div style=' padding: 0.52vw 0; border-bottom: 1px solid #315679;' >
                          <div style=' color: rgba(217, 231, 255, 1)'> 全部材料</div>
                          <div style='font-size: 13px;color: #A1D4ED;line-height: 26px;'> ${params.data.name}&nbsp; ${params.data.value}</div>
                        </div>
                         <div style=' padding: 0.52vw 0; ' >
                          <div style='  color: rgba(217, 231, 255, 1)'> 材料占比</div>
                          <div style='width:316px; display: flex; align-items: center;gap:8px;
                           flex-wrap: wrap;font-size: 13px;   overflow: hidden;'>

                            ${Object.keys(this.materialsInfo[params.data.props]).map(key => {
                return `<div style='min-width:30%;  display: flex; align-items: center;gap:8px; height: 25px;font-size: 13px;color: #A1D4ED;line-height: 13px;'>
                                <div> ${key}</div><div> ${this.materialsInfo[params.data.props][key]}%</div>
                                </div>`
              }).join('')}
                          </div>
                        </div>
                      </div>`
            } else if (params.seriesName === '内圈') {
              html = `
                <div  style='color:#fff; padding: 0 0.52vw;width:316px;'>
                      <div style=' color: rgba(217, 231, 255, 1)'> ${this.typeValue}</div>
                      <div style='width:100%;display:flex;align-items:center; font-size: 13px;color: #A1D4ED;line-height: 26px;'>

                        <div style='min-width:30%;  display: flex; align-items: center;gap:8px;color: #A1D4ED;'>
                          <div> ${params.data.name} </div>
                          <div> ${params.data.value}</div>
                        </div>
                         <div style='min-width:30%;  display: flex; align-items: center;gap:8px;color: #A1D4ED;'>
                          <div>占比</div><div> ${(params.data.stage * 100).toFixed(2)}%</div>
                        </div>
                        ${params.data.diff ?
                  `
                         <div style='min-width:30%;  display: flex; align-items: center;gap:8px;'>
                          <div>${nameMap[params.data.name]}</div><div> ${(params.data.diff * 100).toFixed(2)}%</div>
                        </div>` : '<div></div>'}

                      </div>
                  </div>
                `
            }
            return html
          }
        },
        series: [
          {
            name: '总量',
            type: 'funnel',
            left: '0%',
            width: '100%',
            minSize: '10%',
            sort: 'none',
            // maxSize: 390,
            labelLine: {
              show: false,
            },
            itemStyle: {
              opacity: 0.7,
            },
            label: {
              position: 'inside',
              formatter: '{c}',
              color: '#fff'
            },
            data: this.outSideData,
          },
          {
            name: '内圈',
            type: 'funnel',
            width: `${minWidth * 100}%`,
            left: `${left * 100}%`,
            maxSize: '70%',
            sort: 'none',
            label: {
              position: 'inside',
              formatter: '{c}',
              color: '#fff'
            },
            itemStyle: {
              borderColor: '#fff',
            },
            emphasis: {
              label: {
                position: 'inside',
              },
            },
            data: this.insideData,
            // Ensure outer shape will not be over inner shape when hover.
            z: 100,
          },
        ],
      };

      option && myChart.setOption(option);
      window.addEventListener('resize', function () {
        myChart.resize();
      });
    },
    getMaterialsType() {

      getMaterialsType().then(res => {
        this.typedata = [...this.typedata, ...res.data]
      })
    },
    getMaterialsInfo() {
      getMaterialsInfo({materialTypeName: this.typeValue}).then(res => {
        this.materialsInfo = res.data || {}
        this.formatData(this.materialsInfo)
        this.initfirst()

      })
    },
    formatData(data) {
      this.insideData = []
      this.outSideData = []
      if (this.typeValue === '全部材料') {
        this.outSideData = [{
          value: data.totalBudgetedAmount,
          name: '预算总量',
          stage: data.budgetedAmountRatio,
          props: 'budgetedAmountPercentageByType'
        },
          {
            value: data.totalPurchaseAmount,
            name: '采购量',
            stage: data.purchaseAmountRatio,
            diff: data.budgetedDifference,
            props: 'purchaseAmountPercentageByType'
          },
          {
            value: data.totalReceiveMaterialAmount,
            name: '收料量',
            stage: data.receiveAmountRatio,
            diff: data.purchaseDifference,
            props: 'receiveMaterialAmountPercentageByType'
          },
          {
            value: data.totalInventoryMargin,
            name: '库存余量',
            stage: data.inventoryAmountRatio,
            props: 'inventoryMarginPercentageByType'
          }];

        this.insideData = []
      } else {
        this.insideData = [{value: data.actualBudgetedAmount, name: '预算总量', stage: data.budgetedAmountRatio},
          {
            value: data.actualPurchaseAmount,
            name: '采购量',
            stage: data.purchaseAmountRatio,
            diff: data.budgetedDifference
          },
          {
            value: data.actualReceiveMaterialAmount,
            name: '收料量',
            stage: data.receiveAmountRatio,
            diff: data.purchaseDifference
          },
          {value: data.actualInventoryMargin, name: '库存余量', stage: data.inventoryAmountRatio}];
        this.outSideData = [{
          value: data.totalBudgetedAmount,
          name: '预算总量',
          stage: data.budgetedAmountRatio
        }, {
          value: data.totalPurchaseAmount,
          name: '采购量',
          stage: data.purchaseAmountRatio
        }, {
          value: data.totalReceiveMaterialAmount,
          name: '收料量',
          stage: data.receiveAmountRatio
        }, {value: data.totalInventoryMargin, name: '库存余量', stage: data.inventoryAmountRatio}];


      }
    },
    getMaterialsReceive() {
      getMaterialsReceive({type:'all'}, {
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.current
      }).then(res => {
        this.recordReceiveData = res?.rows || []
        this.pagination.total = res?.total || 0
      })
    },
    tableChange(data) {
      this.pagination = data.pagination;
      this.getMaterialsReceive()
    },
    getVideo() {
      getVideo().then(res => {
        this.videoData = res.data
        this.vediowArr = res.data.map((item, index) => {
          return {
            label: item.channelName,
            select: index
          }
        })
        this.vedioDataItem = this.vedioData[0]
      })
    },
  },
  mounted() {

    // this.setBackImg()
    this.initfirst();
  },
  created() {
    this.getMaterialsType()
    this.getMaterialsInfo()
    this.getMaterialsReceive()
    this.getVideo()
  }

};
</script>

<style lang="scss" scoped>

.total {
  .content {
    .main {
      .mainsingle {
        .inoutlist {
          width: 100%;
          gap: 0.78vw;
          max-height: 100%;
          padding: 0 1.04vw 0.83vw 1.04vw;

          .kongbox {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;

            > img {
              width: 15%;
              margin-bottom: 0.625rem;
            }
          }
        }

        .doorlist {
          width: 100%;
          height: 100%;
          padding: 0 1.04vw;

          .kongbox {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;

            > img {
              width: 15%;
              margin-bottom: 0.625rem;
            }
          }
        }

        .charts {
          .chartsright {
            .rightbot {
              .rightbox {
                height: 30.218vw;
                overflow: hidden;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-between;
                overflow-y: auto;

                .rightright {
                  width: 16.673vw;
                  border: 0.0625rem solid #2f526f;
                  border-radius: 0.21vw;
                  // background: rgba($color: #fff, $alpha: 0.05);
                  background: #173a63;
                  margin-bottom: 0.75rem;

                  .row {
                    // height: 3.168vw;
                    padding: 0 0.52vw;
                    position: relative;

                    .border {
                      padding: 0.52vw 0;
                      border-bottom: 1px solid #315679;
                    }

                    .no-border {
                      padding: 0.52vw 0;
                    }

                    .title {
                      color: rgba(217, 231, 255, 1);
                    }

                    .arrow {
                      position: absolute;
                      right: 0;
                      top: 2vw;

                      .arrow-img {
                        width: 16px;
                        height: 16px;
                      }
                    }

                    .arrow-rotate {
                      transform: rotate(-90deg);
                    }

                    .detial {
                      font-size: 13px;
                      margin-top: 0.502vw;
                      display: flex;
                      align-items: center;
                      flex-wrap: wrap;
                      gap: 8px;
                      height: 25px;
                      overflow: hidden;

                      .detial-item {
                        min-width: 25%;
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        color: #309bc4;
                      }
                    }

                    .expand-detail {
                      height: unset;
                    }

                  }

                }
              }

              #firstcharts {
                margin-top: -6%;
              }

              height: 100%;
              gap: 1.04vw;
            }

            .righttop {
              .righttopsingle {
                img {
                  width: 3.65vw;
                  height: 3.13vw;
                  margin-right: 0.42vw;
                }

                width: 8.85vw;
                height: 100%;
              }

              width: 100%;
              height: 3.13vw;
            }

            gap: 3.126vw;
          }

          .chartsleft {
            width: 9.38vw;
            height: 100%;

            .arrow {
              text-align: center;
              width: 35px;
              height: 18px;
              overflow: hidden;

              background: url('@/assets/image/situation/下拉箭头默认.png');
              background-size: contain;
            }

            .arrow:hover {
              background: url('@/assets/image/situation/下拉箭头高亮.png');
              background-size: contain;
            }

            .arrow-up {
              transform: rotate(180deg);
            }

            .type-content {
              display: flex;
              flex-direction: column;
              align-items: center;
              width: 100%;
              height: 100%;
              max-height: 30vw;
              gap: 1.04vw;
              overflow: scroll;
            }
          }

          padding: 1.04vw;
          gap: 1.04vw;
        }
      }

      padding-left: 2.08vw;
      gap: 1.04vw;
    }

    .zbbox {
      .zblist {
        > img {
          width: 2.5rem;
          margin-left: 6.7%;
        }

        p {
          text-indent: 2.73vw;
          text-align: left;
          margin-left: -1.7vw;
          color: linear-gradient(90deg, #ffffff 0%, #4cbaff 100%);
        }

        height: 100%;
        width: 13.02vw;
        // background: url('../assets/image/meterial/图标背景.png') no-repeat;
        background-position: -0.52vw 0;
        background-size: contain;
        background-repeat: no-repeat;
        display: flex;
        align-items: center;
        justify-content: flex-start;
      }

      .zblist1 {
        position: relative;

        .front-img {
          width: 2.5rem;
          margin-left: 6.7%;
          z-index: 1;
        }

        .img-back {
          position: absolute;
          // width: 100%;
          height: 100%;
          z-index: 0;
          left: -3.7%;
        }

        .count-box {
          z-index: 1;
        }

        p {
          text-indent: 2.73vw;
          text-align: left;
          margin-left: -1.7vw;
          color: #ffedd9;
        }

        height: 100%;
        width: 13.02vw;
        // background: url('../assets/image/meterial/图标背景-黄.png') no-repeat;
        background-position: -0.52vw 0;
        background-size: contain;
        background-repeat: no-repeat;
        display: flex;
        align-items: center;
        justify-content: flex-start;
      }

      height: 4.46vw;
      margin: 0.52vw 0;
      width: 100%;
      padding-left: 3.13vw;
      padding-right: 2.08vw;
    }

    padding-left: 10.89vw;
    padding-right: 1.04vw;
    background: red($color: #000000);
  }

  background: url('../assets/image/bgstaff.png') no-repeat;
}


.bluebg {
  background: rgba(0, 25, 49, 0.5);
  box-shadow: inset 0px 0px 1.5rem 0px rgba(72, 125, 163, 0.5);
  border-radius: 0.5rem;
  border: 1px solid rgba(131, 166, 199, 0.3);
  backdrop-filter: blur(0.1875rem);
  position: relative;

  .gun {
    position: absolute;
    bottom: 1.25rem;
    left: 0;
    width: 100%;
    height: 3.125rem;
    display: flex;

    .left {
      width: 10%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 2.5rem;
      }
    }

    .center {
      width: 80%;
      height: 100%;
      background: url('../assets/image/滚动条.png') no-repeat;
      background-size: 100% 100%;
      background-position: 0 0;
    }

    .right {
      width: 10%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 2.5rem;
      }
    }
  }
}
</style>
<style lang="scss">
.t-table__content {
  height: 540px
}

.t-table__pagination {
  .t-pagination__total {
    color: rgba(217, 231, 255, 1);
  }

  .t-pagination__btn.t-is-disabled {
    color: rgba(217, 231, 255, 1);
  }
}

.count {
  margin-left: 1.03vw;
  font-family: AlibabaPuHuiTi_2_85_Bold;
  font-size: 2rem;
  color: #d9e7ff;
  line-height: 2rem;
  text-shadow: 2px 3px 14px rgba(41, 42, 43, 0.5);
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.type-content::-webkit-scrollbar {
  display: none;
}

.echarts-tooltip {
  background: rgba(46, 83, 127, 0.4);
  box-shadow: 3px 4px 8px 0px rgba(64, 64, 64, 0.3);
  border-radius: 8px;
  border: 2px solid;
  border-image: linear-gradient(221deg, rgba(128, 172, 186, 0), rgba(143, 197, 200, 0.43)) 2 2;
  backdrop-filter: blur(8px);
}
</style>
